// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ArrowSmallLeftIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ArrowSmallLeftIcon" ref={forwardedRef} {...props}>
      <path d="m5.5 10 4.243 4.243 1.06-1.061-2.432-2.432H13v-1.5H8.371l2.432-2.432-1.06-1.06z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ArrowSmallLeftIcon = /* @__PURE__ */ Object.assign(
  ArrowSmallLeftIconComponent,
  { displayName: 'ArrowSmallLeftIcon' },
);
